import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=28d57fa9&"
import script from "./SearchModal.vue?vue&type=script&lang=js&"
export * from "./SearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports